"use client";
import React, { useState } from "react";
import HeroPage3 from "../components/HeroPage3";
import CardGrid from "src/app/components/CardGrid";
import { AnnouncementCard } from "../components/Announcements";
import Button from "src/app/components/ui/Button";
import DefaultPageComponent from "src/app/components/ui/DefaultPageComponent";
import { DefaultSvg } from "src/app/components/Icon";
import { Announcement } from "src/types";
import { useThrottledSearch } from "src/app/components/useThrottleSearch";
import { useAnnouncements } from "src/app/lib/useAnnouncementsPage";
import { FilterBar } from "../../design1/components/HomeFilterBar";

// const isDemoMode = process.env.NEXT_PUBLIC_DEMO_MODE === "true";

const Search = ({
  setSearch,
}: {
  setSearch: (val: string | undefined) => void;
}) => {
  const { handleSearchChange } = useThrottledSearch({
    initialSearch: "",
    delay: 1000,
    onSearchChange: setSearch,
  });
  return (
    <div className=" text-white md:w-full flex-1">
      <h1 className="font-semibold  mb-8">Announcements</h1>
      <div className=" bg-white rounded-xl w-full max-w-[500px]  items-center p-1 pl-3  flex justify-between">
        <div
          className=" flex w-full gap-1 basis-full flex-1 items-center
    "
        >
          <input
            onChange={handleSearchChange}
            placeholder="Search"
            className="outline-none block flex-1 w-full text-base  placeholder:text-disabled-main focus:outline-none text-primary border-none"
            type="text"
          />
        </div>
        <div className="cursor-pointer">
          <SearchBtn />
        </div>
      </div>
    </div>
  );
};

const Announcement3 = ({
  announcements,
}: {
  announcements: Announcement[];
}) => {
  const [search, setSearch] = useState<string | undefined>(undefined);
  return (
    <section className="max-w-full overflow-clip">
      <HeroPage3>
        <div className="flex items-center md:items-start gap-6 md:flex-col justify-between">
          <Search setSearch={setSearch} />
          <div className="p max-w-2xl text-xl texl-xl">
            Stay Your next move starts here-browse, find, and secure your
            perfect property today&quot; Your next move starts here-browse,
            find, and secure
          </div>
        </div>
      </HeroPage3>
      <AnnouncementWrapper
        prefetchedAnnouncements={announcements}
        search={search}
      />
    </section>
  );
};
export default Announcement3;

const AnnouncementWrapper = ({
  search,
  prefetchedAnnouncements,
}: {
  search?: string | undefined;
  prefetchedAnnouncements: Announcement[];
}) => {
  const {
    setSort,
    announcements,
    isLoading,
    showDefault,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useAnnouncements({ search, prefetchedAnnouncements });

  const isFiltering = !!search?.trim();

  return (
    <div className="wrapper py-6">
      <div className="sorts ">
        <FilterBar setSearch={() => {}} setSort={setSort} />
        {/* <FilterBar /> */}
      </div>

      {isLoading && !prefetchedAnnouncements?.length ? (
        <div>Loading announcements...</div>
      ) : isFiltering && announcements.length === 0 ? (
        <div>No announcements match your search.</div>
      ) : showDefault ? (
        <div>
          <DefaultPageComponent
            image="/images/not-found-optimize.gif"
            text={`No Results Found.
We couldn’t find any post matching your search. This might be due to limited availability, overly specific filters, or a typo in your search. Try using broader keywords, adjusting your filters, or simplifying your terms.`}
            svg={DefaultSvg}
          />
        </div>
      ) : (
        <CardGrid minCardWidth={300}>
          {announcements.map((announcement, index) => (
            <div key={index} className="item h-full">
              <AnnouncementCard
                className="!max-w-[350px] sm:!max-w-full sm:!w-full !w-full"
                {...announcement}
              />
            </div>
          ))}
        </CardGrid>
      )}

      {hasNextPage && (
        <Button
          className="w-max primary-btn mt-8 block mx-auto"
          onClick={() => fetchNextPage()}
          disabled={isFetchingNextPage}
        >
          {isFetchingNextPage ? "Loading..." : "Load more"}
        </Button>
      )}
    </div>
  );
};

export const SearchIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.4998 2C9.14436 2.00012 7.80863 2.32436 6.60402 2.94569C5.39941 3.56702 4.36086 4.46742 3.575 5.57175C2.78914 6.67609 2.27878 7.95235 2.08647 9.29404C1.89417 10.6357 2.02551 12.004 2.46954 13.2846C2.91357 14.5652 3.65741 15.7211 4.639 16.6557C5.62059 17.5904 6.81147 18.2768 8.11228 18.6576C9.41309 19.0384 10.7861 19.1026 12.1168 18.8449C13.4475 18.5872 14.6972 18.015 15.7618 17.176L19.4138 20.828C19.6024 21.0102 19.855 21.111 20.1172 21.1087C20.3794 21.1064 20.6302 21.0012 20.8156 20.8158C21.001 20.6304 21.1062 20.3796 21.1084 20.1174C21.1107 19.8552 21.0099 19.6026 20.8278 19.414L17.1758 15.762C18.1638 14.5086 18.7789 13.0024 18.9509 11.4157C19.1228 9.82905 18.8446 8.22602 18.148 6.79009C17.4514 5.35417 16.3646 4.14336 15.0121 3.29623C13.6595 2.44911 12.0957 1.99989 10.4998 2ZM3.99977 10.5C3.99977 8.77609 4.68458 7.12279 5.90357 5.90381C7.12256 4.68482 8.77586 4 10.4998 4C12.2237 4 13.877 4.68482 15.096 5.90381C16.3149 7.12279 16.9998 8.77609 16.9998 10.5C16.9998 12.2239 16.3149 13.8772 15.096 15.0962C13.877 16.3152 12.2237 17 10.4998 17C8.77586 17 7.12256 16.3152 5.90357 15.0962C4.68458 13.8772 3.99977 12.2239 3.99977 10.5Z"
        fill="#A4A7B0"
      />
    </svg>
  );
};

// {/* export const FilterBar: React.FC = () => {
//   return (
//     <div className="flex justify-between items-center w-full p-4 rounded-lg">
//       {/* Search Bar */}

//       {/* Sort Dropdown */}
//       <div>
//         <select className="p-2 px-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
//           <option>Sort By: Default</option>
//           <option>Sort By: Most Recent</option>
//           <option>Sort By: Oldest</option>
//           <option>Sort By: Most Read</option>
//         </select>
//       </div>
//     </div>
//   );
// }; */}

export const SearchBtn = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0H40C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H0V0Z"
        fill="var(--primary-color)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.7507 15.666C21.6212 15.6661 20.5081 15.9363 19.5042 16.4541C18.5004 16.9719 17.6349 17.7222 16.9801 18.6425C16.3252 19.5628 15.8999 20.6263 15.7396 21.7444C15.5794 22.8625 15.6888 24.0027 16.0588 25.0698C16.4289 26.137 17.0487 27.1002 17.8667 27.8791C18.6847 28.658 19.6771 29.23 20.7611 29.5473C21.8451 29.8647 22.9893 29.9182 24.0982 29.7034C25.2071 29.4887 26.2486 29.0118 27.1357 28.3127L30.179 31.356C30.3362 31.5078 30.5467 31.5918 30.7652 31.5899C30.9837 31.588 31.1927 31.5004 31.3472 31.3459C31.5017 31.1914 31.5894 30.9823 31.5913 30.7639C31.5932 30.5454 31.5092 30.3349 31.3574 30.1777L28.314 27.1343C29.1374 26.0899 29.65 24.8347 29.7933 23.5125C29.9366 22.1902 29.7047 20.8544 29.1242 19.6578C28.5437 18.4612 27.6381 17.4521 26.511 16.7462C25.3838 16.0403 24.0807 15.6659 22.7507 15.666ZM17.334 22.7493C17.334 21.3128 17.9047 19.935 18.9205 18.9192C19.9364 17.9034 21.3141 17.3327 22.7507 17.3327C24.1873 17.3327 25.565 17.9034 26.5809 18.9192C27.5967 19.935 28.1674 21.3128 28.1674 22.7493C28.1674 24.1859 27.5967 25.5637 26.5809 26.5795C25.565 27.5953 24.1873 28.166 22.7507 28.166C21.3141 28.166 19.9364 27.5953 18.9205 26.5795C17.9047 25.5637 17.334 24.1859 17.334 22.7493Z"
        fill="white"
      />
    </svg>
  );
};
